<template>
  <validation-observer ref="validationobserver" v-slot="{ }">
    <b-form @submit.prevent="salvarProrrogacao" id="editar-prorrogacao">
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">
              {{ isEdit ? 'Editar' : 'Cadastrar' }} Prorrogação
            </span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="save" />
              Salvar
            </b-button>
          </h6>
        </template>
        <b-card-body>
          <b-row>
            <b-col cols="6" lg="4">
              <b-form-group id="input-group-type" label-size="md" label="Tipo Prorrogação">
                <b-form-select id="select-filtros-referencia" @change="checkTipoLRF()" :disabled="isEdit"
                  v-model="prorrogacao.TipoProrrogacao" :options="comboTipoProrrogacao">
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6" lg="4">
              <validation-provider rules="required" v-slot="validationContext" name="exercicio">
                <b-form-group id="input-group-type" label-size="md" label="Exercício (ano)*">
                  <b-form-select id="select-exercicio" :disabled="isEdit" v-model="prorrogacao.Exercicio"
                    :options="comboExercicios" :state="getValidationState(validationContext)">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-exercicio-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group id="input-group-type" label-size="md" label="Referência (mês)">
                <b-form-select id="select-filtros-referencia" :disabled="isEdit" v-model="prorrogacao.MesRef"
                  :options="comboReferencias">
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="3">
              <b-form-group label-class="text-left" id="protocolo-input-group" label="Protocolo de Autorização *"
                label-for="input-protocolo">
                <b-form-input id="input-protocolo" class="w-100" v-model="prorrogacao.NrProtocoloAutorizacao">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="5">
              <b-form-group label-class="text-left" label="Unidade Gestora" label-for="unidade-gestora">
                <multiselect v-model="prorrogacao.UnidadeGestora" id="unidade-gestora" :disabled="isEdit"
                  open-direction="bottom" :close-on-select="true" :searchable="true" label="Nome" :show-labels="false"
                  deselect-label="" :allow-empty="true" placeholder="Selecione" track-by="Codigo" :options="optionsUG">
                  <template slot="noOptions">
                    <small><i>Erro ao obter dados.</i></small>
                  </template>
                  <template slot="noResult">
                    <i>Sem resultados.</i>
                  </template>
                </multiselect>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="4">
              <b-form-group label-class="text-left" id="data-vencimento-input-group" label="Data de Vencimento *"
                label-for="input-data-vencimento">
                <b-form-datepicker id="input-data-vencimento" v-model="prorrogacao.DataVencimento"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="isTipoProrrogacaoLRF">
            <b-col cols="6" lg="4">
              <b-form-group id="input-group-type" label-size="md" label="Tipo de Relatório">
                <b-form-select id="select-filtros-referencia" :disabled="isEdit" @change="checkTipoLRF"
                  v-model="prorrogacao.IdTipoRelatorio" :options="comboTiposRelatorios">
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6" lg="4">
              <validation-provider rules="required" v-slot="validationContext" name="periodo_relatorio">
                <b-form-group id="input-group-type" label-size="md" label="Período do Relatório">
                  <b-form-select id="select-periodo-relatorio" :disabled="isEdit" v-model="prorrogacao.IdPeriodoRelatorio"
                    :options="comboPeriodosRelatorios" :state="getValidationState(validationContext)">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-exercicio-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import Multiselect from "vue-multiselect";
import { ReferenciasValidas } from '@/types/administracao/referencias-validas'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { store } from "@/store";
import { UtilsTS } from '@/utilsts'

import prorrogacaoService from "@/services/administracao/prorrogacaoService";
import { Prorrogacoes } from '@/types/administracao/prorrogacoes'
import { UnidadeGestoraResumida } from '@/types/ug/unidade-gestora-resumida';
import ugService from "@/services/administracao/ugService"
import { SelectValue } from '@/types/select-value';

const CompProps = Vue.extend({
  name: 'EditarProrrogacao',
  components: {
    BtnVoltar,
    ValidationProvider,
    Multiselect,
    ValidationObserver,
  },
  props: {
    idProrrogacao: {
      type: String,
      required: false
    }
  }
})

@Component
export default class EditarProrrogacao extends mixins(UtilsTS, CompProps) {
  @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
  comboExercicios: SelectValue[] = []
  comboReferencias: SelectValue[] = []
  comboTiposRelatorios: SelectValue[] = []
  comboTipoProrrogacao: SelectValue[] = []
  comboPeriodosRelatorios: SelectValue[] = []
  prorrogacao = new Prorrogacoes()
  optionsUG: UnidadeGestoraResumida[] = []
  isBusy = false
  isTipoProrrogacaoLRF = false

  get isEdit() {
    return this.idProrrogacao !== undefined && this.idProrrogacao !== null
  }

  async salvarProrrogacao(): Promise<void> {
    try {
      store.blockScreen = true
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver)
        return
      }
      const response = this.isEdit ? await prorrogacaoService.alterarProrrogacao(this.prorrogacao) : await prorrogacaoService.adicionarProrrogacao(this.prorrogacao);
      if (response && response.status == 200) {
        this.$toast.success(`Prorrogação ${this.isEdit ? 'editada' : 'cadastrada'} com sucesso!`);
        this.$router.push("/seguranca-administracao/prorrogacoes");
      } else if (response && response.data.msg) {
        this.$toast.error(response.data.msg || "Erro ao salvar prorrogação");
      }
      else {
        this.$toast.error("Erro ao salvar prorrogação");
      }
    } catch (e: any) {
      console.error('Erro ao salvar prorrogação', e, this.prorrogacao)
      this.$toast.error(e.response?.data.msg || "Erro ao salvar prorrogação")
    } finally {
      store.blockScreen = false
    }
  }

  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }

  checkTipoLRF() {
    this.isTipoProrrogacaoLRF = this.prorrogacao.TipoProrrogacao == 'LRF'
  }

  async obterUgsAtivas(): Promise<void> {
    try {
      const response = await ugService.obterUgsAtivas()
      if (response && response.status === 200) {
        this.optionsUG = this.formatedUGLabels(response.data)
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao buscar UGs ativas!')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.isBusy = false
    }
  }

  setUnidadeGestora(): void {
    this.prorrogacao.UnidadeGestora = this.optionsUG.find(ug => {
      return ug.IdPCM == this.prorrogacao.IdUnidadeGestora
    })
  }

  async mounted(): Promise<void> {
    try {
      store.blockScreen = true
      await this.obterUgsAtivas()
      if (this.isEdit) {
        const prorrogacaoRequest = await prorrogacaoService.getProrrogacaoByID(this.idProrrogacao)
        if (prorrogacaoRequest && prorrogacaoRequest.status === 200) {
          this.prorrogacao = Object.assign(this.prorrogacao, prorrogacaoRequest.data)
          this.prorrogacao.tratarDadosDaAPI()
        } else {
          this.$router.push("/seguranca-administracao/prorrogacao");
          this.$toast.error(prorrogacaoRequest.data.msg || "Erro ao carregar prorrogação");
        }
        this.isTipoProrrogacaoLRF = this.prorrogacao.TipoProrrogacao == 'LRF'
        this.setUnidadeGestora()
      }
      else {
        this.prorrogacao.TipoProrrogacao = "0"
        this.prorrogacao.TipoRelatorio = "0"
        this.isTipoProrrogacaoLRF = false
      }
      const ano = new Date().getFullYear()
      this.comboExercicios = [
        { text: String(ano - 2), value: ano - 2 },
        { text: String(ano - 1), value: ano - 1 },
        { text: String(ano), value: ano },
        { text: String(ano + 1), value: ano + 1 },
      ]
      this.comboReferencias = ReferenciasValidas.map(r => {
        return { text: String(r), value: r }
      })
      this.comboTipoProrrogacao = [{ value: "0", text: 'Selecione', disabled: true }].concat((await prorrogacaoService.buscarTiposProrrogacao()).data.map(r => {
        return { text: String(r), value: r }
      }))
      this.comboPeriodosRelatorios = [{ value: "0", text: 'Selecione', disabled: true }].concat((await prorrogacaoService.buscarPeriodosRelatoriosLRF()).data.map(r => {
        return { text: String(r.DePeriodorelatorio), value: r.IdPeriodorelatorio }
      }))
      this.comboTiposRelatorios = [{ value: "0", text: 'Selecione', disabled: true }].concat((await prorrogacaoService.buscarTiposRelatoriosLRF()).data.map(r => {
        return { text: String(r.DeTiporelatorio), value: r.IdTiporelatorio }
      }))

    } catch (e: any) {
      console.error('Erro ao montar edição de prorrogações', e)
      this.$router.push("/seguranca-administracao/prorrogacao");
      this.$toast.error(e.message || "Erro ao carregar prorrogação");
    } finally {
      store.blockScreen = false
    }
  }
};
</script>

<style>
#editar-prorrogacao .multiselect {
  display: inline-block;
  width: 100%;
}

#editar-prorrogacao .multiselect__tags {
  border: #007d47 solid 1px !important;
  border-radius: 3px !important;
  overflow: hidden;
  min-height: 40px !important;
}


#editar-prorrogacao .multiselect__tags {
  padding: 6px 40px 0 8px;
}
</style>